import Vue from 'vue';
import * as act from '@/store/components.actions';
import { ComponentsStorage, AppComponents } from '@/models/components-store.models';

const state = new ComponentsStorage();

const actions = {};

const mutations = {
  [act.MUT_DATA](state: ComponentsStorage, { componentName, componentData }): void {
    Vue.set(state, componentName, JSON.parse(JSON.stringify(componentData || null)));
  },
  [act.MUT_RESET](state: ComponentsStorage, { componentName }): void {
    delete state[componentName];
  }
};

const getters = {
  [act.GET_DATA]: (state: ComponentsStorage) => (componentName: AppComponents) => {
    return JSON.parse(JSON.stringify(state[componentName] || null));
  }
};

export const components = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
